import Modal from '../../Modal/Modal';
import React from 'react';
import PromiseButton from '../../PromiseButton';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onDownload: (includeArchived: boolean) => Promise<void>;
}

interface State {
    includeArchived: boolean;
}

class DownloadReportConfigSummaryModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            includeArchived: false
        };
    }

    componentDidUpdate(prevProps: Props): void {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.setState({ includeArchived: false });
        }
    }

    render(): JSX.Element {
        return (
            <Modal state={{ isOpen: this.props.isOpen, title: 'Download Summary of Reporting Config', error: '' }} close={this.props.onClose}>
                <p className='margin-bottom-15px'>Summary includes Active configurations only.</p>
                <label className='display-flex align-items-center margin-bottom-20px'>
                    <input
                        type='checkbox'
                        checked={this.state.includeArchived}
                        onChange={(e) => this.setState({ includeArchived: e.target.checked })}
                    />
                    <span className='margin-left-8px'>Include Archived Configs</span>
                </label>
                <div className='display-flex align-center justify-content-start'>
                    <PromiseButton
                        className='btn cb-btn margin-right-10px'
                        enableOnErrorOnly={false}
                        task={async () => { await this.props.onDownload(this.state.includeArchived); }}
                    >
                        Download
                    </PromiseButton>
                    <button type='button' className='btn btn-light' onClick={this.props.onClose}>Cancel</button>
                </div>
            </Modal>
        );
    }
}

export default DownloadReportConfigSummaryModal;
